/* eslint-disable @typescript-eslint/no-explicit-any */
import type { Theme } from "@mui/material/styles";

export default function DataGrid(theme: Theme): any {
  return {
    MuiDataGrid: {
      styleOverrides: {
        panel: {
          // Makes the DataGrid Popovers (Filter, Hide/Show Columns) stay behind the Sidebar
          // when the Sidebar is open
          zIndex: theme.zIndex.drawer - 1,
        },
        columnMenu: { backgroundColor: "red" },
      },
    },
  };
}
